<template>
  <v-menu v-model="datepicker" ref="date_picker" transition="scale-transition" offset-y :close-on-content-click="false">
    <template #activator="{ on, attrs }">
      <v-text-field
        :label="label"
        :value="_formattedDate"
        persistent-hint
        v-bind="{ ...attrs, ...attributes }"
        v-on="on"
        readonly
        :error-messages="errorMessages"
        @click:append="handleInput(null)"
        @click:clear="handleInput(null)"
        :tabindex="tabindex"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :first-day-of-week="1"
      @input="handleInput"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "Datepicker",
  props: {
    label: {
      type: String,
      default: "Date"
    },
    value: {
      type: String,
      default: null
    },
    tabindex: {
      type: Number,
      default: 0
    },
    errorMessages: {},
    attributes: {}
  },
  watch: {
    value(newValue) {
      // if (!newValue) {
        this.date = newValue;
      // }
    }
  },
  data() {
    return {
      date: this.value,
      datepicker: false
    };
  },
  computed: {
    _formattedDate() {
      return this.date ? Vue.moment(this.date).format("YYYY.MM.DD") : null;
    }
  },
  methods: {
    handleInput(date) {
      this.datepicker = false;
      this.$emit("input", date);
    }
  }
};
</script>
